import { DownloadLogsReqData } from "./DownloadLogsReqData";

export class DownloadLogsProgress extends DownloadLogsReqData {
    downloadedDays: Date[] = [];
    isDownloadCompleted: boolean = false;
    agentVersion: string;

    constructor() {
        super();
    }

    public parse(obj: any) {
        super.parse(obj);

        if (obj.DownloadedDays && obj.DownloadedDays.length > 0)
            obj.DownloadedDays.forEach((element) => {
                this.downloadedDays.push(element);
            });

        if (obj.IsDownloadCompleted != null) this.isDownloadCompleted = obj.IsDownloadCompleted;

        if (obj.AgentVersion) this.agentVersion = obj.AgentVersion;
    }

    public getDownloadLogsReqData(): DownloadLogsReqData {
        var reqData: DownloadLogsReqData = new DownloadLogsReqData();
        reqData.installationName = this.installationName;
        reqData.machineSerialNumbers = this.machineSerialNumbers;
        reqData.startDate = this.startDate;
        reqData.endDate = this.endDate;
        reqData.logsFamily = this.logsFamily;
        reqData.logTypes = [];
        this.logTypes.forEach((t) => {
            reqData.logTypes.push(t);
        });
        return reqData;
    }
}
